var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilkTracking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9V10.9081C3 13.3419 3 14.5588 3.66455 15.383C3.79881 15.5495 3.95048 15.7012 4.117 15.8354C4.94123 16.5 6.15812 16.5 8.59185 16.5C9.12105 16.5 9.38558 16.5 9.6279 16.4145C9.6783 16.3967 9.72765 16.3762 9.77588 16.3532C10.0077 16.2423 10.1948 16.0552 10.5689 15.6811L14.1213 12.1287C14.5549 11.6951 14.7716 11.4784 14.8859 11.2027C15 10.927 15 10.6204 15 10.0073V7.5C15 4.67157 15 3.25736 14.1213 2.37868C13.2427 1.5 11.8284 1.5 9 1.5M9.75 16.125V15.75C9.75 13.6287 9.75 12.568 10.409 11.909C11.0681 11.25 12.1287 11.25 14.25 11.25H14.625",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.75C7.05762 3.29487 5.8802 1.5 5.25 1.5C4.6198 1.5 3.44238 3.29487 3 3.75M5.25 2.25V7.5",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilkTracking);
export default __webpack_public_path__ + "static/media/builk-tracking.3f863c5f796e6026b1b5d8f720f2334f.svg";
export { ForwardRef as ReactComponent };